"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Orientation;
(function (Orientation) {
    Orientation["PORTRAIT"] = "PORTRAIT";
    Orientation["LANDSCAPE"] = "LANDSCAPE";
    Orientation["PORTRAIT_FLIPPED"] = "PORTRAIT_FLIPPED";
    Orientation["LANDSCAPE_FLIPPED"] = "LANDSCAPE_FLIPPED";
    Orientation["AUTO"] = "AUTO";
})(Orientation || (Orientation = {}));
exports.default = Orientation;
